import {CreatureStatPanel} from "@/scenes.ui/creature-stat-panel";
import SceneUtils from "@/utils/scene-utils";

export default class StatPanelUtils {

    private static creatureStatPanel: CreatureStatPanel | undefined;

    public static getCreatureStatPanel() {
        if (!StatPanelUtils.creatureStatPanel) {
            StatPanelUtils.creatureStatPanel = new CreatureStatPanel(SceneUtils.getCurrentScene()!);
            SceneUtils.getCurrentScene()!.add.existing(StatPanelUtils.creatureStatPanel);
        }

        if (StatPanelUtils.creatureStatPanel.scene !== SceneUtils.getCurrentScene()) {
            StatPanelUtils.creatureStatPanel = new CreatureStatPanel(SceneUtils.getCurrentScene());
            SceneUtils.getCurrentScene().add.existing(StatPanelUtils.creatureStatPanel);
        }

        return StatPanelUtils.creatureStatPanel;
    }

    public static isCreatureStatPanelVisible() {
        return StatPanelUtils.creatureStatPanel && !StatPanelUtils.creatureStatPanel.isWindowDestroyed() && StatPanelUtils.creatureStatPanel.visible;
    }
}
